const mutations = {
  mutationCommercialLines(state, payload) {
    if (payload && (payload.tab || payload.tab === 0)) {
      state.commercialLines[payload.tab] = payload.responseData;
    } else {
      state.commercialLines = payload;
    }
  },

  mutationCommercialLinesMeta(state, payload) {
    state.commercialLinesMeta = payload;
  },

  mutationQuickViews(state, payload) {
    state.quickViews = payload;
  },

  mutationCommercialLineDetail(state, payload) {
    state.commercialLine = payload;
  },

  mutationListProductCategory(state, payload) {
    state.listProductCategory = payload;
  },
};

export default mutations;
